import { useRef, useEffect } from 'react';
import './SpotlightCard.css';

const SpotlightCard = ({ children, className = '', spotlightColor = 'rgba(124, 58, 237, 0.25)' }) => {
  const divRef = useRef(null);
  const rafRef = useRef(null);
  const mouseRef = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const currentRef = useRef({ x: 0, y: 0 }); // interpolated position
  const isHoveredRef = useRef(false);

  useEffect(() => {
    const el = divRef.current;
    if (!el) return;

    el.style.setProperty('--spotlight-color', spotlightColor);

    // Track global mouse position at all times
    const onGlobalMouseMove = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener('mousemove', onGlobalMouseMove);

    // Animate — always lerp toward mouse (global or local)
    const animate = () => {
      const rect = el.getBoundingClientRect();

      let targetX, targetY;

      if (isHoveredRef.current) {
        // Follow actual mouse relative to card
        targetX = mouseRef.current.x - rect.left;
        targetY = mouseRef.current.y - rect.top;
      } else {
        // Project global mouse onto card — spotlight "feels" the cursor
        // even when not directly hovered
        targetX = mouseRef.current.x - rect.left;
        targetY = mouseRef.current.y - rect.top;
      }

      // Smooth lerp so it always moves fluidly
      currentRef.current.x += (targetX - currentRef.current.x) * 0.06;
      currentRef.current.y += (targetY - currentRef.current.y) * 0.06;

      el.style.setProperty('--mouse-x', `${currentRef.current.x}px`);
      el.style.setProperty('--mouse-y', `${currentRef.current.y}px`);

      rafRef.current = requestAnimationFrame(animate);
    };

    // Init current position to center of card
    const rect = el.getBoundingClientRect();
    currentRef.current = { x: rect.width / 2, y: rect.height / 2 };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener('mousemove', onGlobalMouseMove);
    };
  }, [spotlightColor]);

  return (
    <div
      ref={divRef}
      onMouseEnter={() => { isHoveredRef.current = true; }}
      onMouseLeave={() => { isHoveredRef.current = false; }}
      className={`card-spotlight ${className}`}
    >
      {children}
    </div>
  );
};

export default SpotlightCard;
